import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { CountdownModule } from 'ngx-countdown';
import { SharedComponentsModule } from '../../core/shared-components.module';
import { SmsOtpVerificationComponent } from './components/sms-otp-verification/sms-otp-verification.component';

import { GeneralRoutingModule } from './general-routing.module';
import { DemoComponent } from './pages/demo/demo.component';
import { LoginComponent } from './pages/login/login.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';


@NgModule({
  declarations: [LoginComponent, DemoComponent, SmsOtpVerificationComponent, ChangePasswordComponent,ForgotPasswordComponent],
  imports: [
    CommonModule,
    GeneralRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    SharedComponentsModule,
    NgOtpInputModule,
    CountdownModule,
  ],
})
export class GeneralModule {}
